import {
    toggleClass
} from './../../functions/general-functions';

import debounce from "lodash/debounce";
import gsap from 'gsap';

import axios from "axios";
import epica from "../../features/epica";
import {
    execute
} from "../../features/lazy-load";


export const insideHomeMixin = {
    created: function () {
        this.yt = new YoutubeLR();
        this.yt.init();
        this.idx = this.yt.idx;
        this.playlist = aa;
        this.selectedPlayer = Object.assign({}, this.selectedPlayer, this.playlist[this.idx]);
        let last_known_scroll_position = 0;
        let ticking = false;
        const fixedVideo = document.getElementById('video-inside-fixed');

        const _self = this;
        window.addEventListener('scroll', function (e) {
            last_known_scroll_position = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    _self.scrolled(last_known_scroll_position);
                    ticking = false;
                });
            }
            ticking = true;
        });
    },
    mounted: function () {
        this.isFixed = window.scrollY > 500;
    },
    methods: {
        toggleMenu: function () {
            this.menuActive = !this.menuActive;
            toggleClass(document.querySelector('footer'), "footer-with-menu");
        },
        playVideo: function (idx, e) {
            e.preventDefault();
            this.idx = idx;
            this.selectedPlayer = Object.assign({}, this.selectedPlayer, this.playlist[this.idx]);
            this.yt.playVideo(idx);
        },
        scrolled: function (y) {
            this.isFixed = y > 500;
        },
        toggleShareBox: function () {
            this.isOpenShareBox = !this.isOpenShareBox;
            if (this.isOpenShareBox) {
                gsap.to(this.$refs.socialShareBox, {
                    duration: 0.25,
                    height: 180,
                    autoAlpha: 1
                });
            } else {
                gsap.to(this.$refs.socialShareBox, {
                    duration: 0.25,
                    height: 0,
                    autoAlpha: 0
                });
            }
        }
    },
    data: function () {
        return {
            menuActive: true,
            selectedPlayer: {},
            isFixed: false,
            isOpenShareBox: false
        };
    }
};


export const insideResultsMixin = {
    beforeMount: function () {
        this.sort = document.getElementById('inside-results').dataset.sort;
    },
    watch: {
        isMenuShow: function (newVal, oldVal) {
            if (newVal) {
                document.body.classList.add("overflow-hidden");
            } else {
                document.body.classList.remove("overflow-hidden");
            }
        }
    },
    updated: function () {
        if (!this.topic || this.topic == "") {
            execute();
        }
        epica();
    },
    methods: {
        toggleMenu: function () {
            this.menuActive = !this.menuActive;
            toggleClass(document.querySelector('footer'), "footer-with-menu");
        },
        changeSort: function () {
            if (this.sort) {
                document.location.href = this.sort
            }
        },
        clearACTopic: function () {
            this.topic = "";
            this.autocomplete();
        },
        autocomplete: debounce(
            function () {
                this.searching = true;
                const _self = this;
                if (this.topic) {
                    const params = {
                        term: this.topic,
                    };
                    axios.get('/api/inside/ac', { params }).then(function (d) {
                        _self.acResult = d.data;
                        _self.searching = false;
                    });
                }
            },
            250
        )
    },
    computed: {
        noResults: function () {
            return !this.topic && this.acResult.length === 0;
        }
    },
    filters: {
        uppercase: function (v) {
            return v.toUpperCase()
        }
    },
    data: function () {
        return {
            menuActive: true,
            topic: "",
            acResult: [],
            searching: false,
            sort: ""
        };
    }
};

class YoutubeLR {
    constructor() {
        this.idx = 0;
        this.player = {};
    }
    init() {
        const _self = this;
        window.onpopstate = function (event) {
            if (event.state) {
                _self.playVideo(event.state.idx, true);
            }
        };
        window.onYouTubeIframeAPIReady = function () {
            _self.onYouTubeIframeAPIReady();
        }
        window.onReadyYT = function () {
            _self.onReadyYT();
        }
        window.onStateChangeYT = function (ee) {
            _self.onStateChangeYT(ee);
        }
        this.initIframeApi();
    }
    initIframeApi() {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    onYouTubeIframeAPIReady() {
        this.player = new YT.Player('video-player', {
            height: '315',
            width: '560',
            events: {
                'onReady': onReadyYT,
                'onStateChange': onStateChangeYT
            }
        });
    }

    onReadyYT() {
        this.playVideo();
    }

    onStateChangeYT(ee) {
        if (ee.data === 0) {
            this.idx++;
            this.playVideo(this.idx);
        }
    }

    playVideo(ix, ignorehistory) {
        if (!ignorehistory) {
            if (ix === undefined) {
                ix = 0;
                history.replaceState({
                    idx: ix
                }, '', aa[ix].insideVideoUrl);
            } else {
                history.pushState({
                    idx: ix
                }, '', aa[ix].insideVideoUrl);
            }
        }
        this.idx = ix;
        this.player.loadVideoById(aa[ix].videoId);
    }
}